/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  INFOCOPY_REVIEW_IFPAYMENTISTIMELYSUBMITTED: 'payments.oneTimePayment.infoCopy.review.ifPaymentIsTimelySubmitted',
  PAYMENTFIELDS_ADDITIONALESCROW_LABEL: 'payments.oneTimePayment.paymentFields.additionalEscrow.label',
  PAYMENTFIELDS_ADDITIONALPRINCIPAL_LABEL: 'payments.oneTimePayment.paymentFields.additionalPrincipal.label',
  PAYMENTFIELDS_LATECHARGE_LABEL: 'payments.oneTimePayment.paymentFields.lateCharge.label',
  PAYMENTFIELDS_NSFFEES_LABEL: 'payments.oneTimePayment.paymentFields.nsfFees.label',
  PAYMENTFIELDS_OTHERFEES_LABEL: 'payments.oneTimePayment.paymentFields.otherFees.label',
  TOOLTIP_ADDITIONALPAYMENTS_CONTENT: 'payments.oneTimePayment.tooltip.additionalPayments.content',
  TOOLTIP_ADDITIONALPAYMENTS_TITLE: 'payments.oneTimePayment.tooltip.additionalPayments.title',
  TOOLTIP_LINKTEXT: 'payments.oneTimePayment.tooltip.linkText',
  TOOLTIP_NUMBEROFMONTHLYPAYMENTS_CONTENT: 'payments.oneTimePayment.tooltip.numberOfMonthlyPayments.content',
  TOOLTIP_NUMBEROFMONTHLYPAYMENTS_TITLE: 'payments.oneTimePayment.tooltip.numberOfMonthlyPayments.title',
  TOOLTIP_REGULARMONTHLYPAYMENT_CONTENT: 'payments.oneTimePayment.tooltip.regularMonthlyPayment.content',
  TOOLTIP_REGULARMONTHLYPAYMENT_TITLE: 'payments.oneTimePayment.tooltip.regularMonthlyPayment.title',
};

const enMessages = {
  // Info Copy Review
  [IDS.INFOCOPY_REVIEW_IFPAYMENTISTIMELYSUBMITTED]: 'If a payment is timely submitted within the late fee grace period, but not processed until on or after the grace period has expired, a late fee may be assessed and then subsequently reversed. If this occurs, you may receive a billing statement reflecting a late fee. This late fee does not need to be paid and will be reversed once the payment is posted and back dated to the date submitted. The next monthly statement will be sent with the adjustment. If you have any questions regarding One-Time Drafting, please contact our <a>Customer Service Department</a>.',
  // Additional Payment Fields
  [IDS.PAYMENTFIELDS_ADDITIONALPRINCIPAL_LABEL]: 'Additional Principal',
  [IDS.PAYMENTFIELDS_ADDITIONALESCROW_LABEL]: 'Additional Escrow',
  [IDS.PAYMENTFIELDS_LATECHARGE_LABEL]: 'Late Fees',
  [IDS.PAYMENTFIELDS_NSFFEES_LABEL]: 'NSF Fee',
  [IDS.PAYMENTFIELDS_OTHERFEES_LABEL]: 'Other Fees',
  // Tooltips
  [IDS.TOOLTIP_ADDITIONALPAYMENTS_CONTENT]: 'Add additional funds to your monthly payment. Select from Additional Escrow, Principal, or Late fees if applicable.',
  [IDS.TOOLTIP_ADDITIONALPAYMENTS_TITLE]: 'Add an Additional Payment',
  [IDS.TOOLTIP_LINKTEXT]: 'Got it',
  [IDS.TOOLTIP_NUMBEROFMONTHLYPAYMENTS_CONTENT]: 'You have the option to repeat this payment automatically for up to {maxMonth} consecutive months. Please note, this is not the same functionality as autopay.',
  [IDS.TOOLTIP_NUMBEROFMONTHLYPAYMENTS_TITLE]: 'Number of Monthly Payments',
  [IDS.TOOLTIP_REGULARMONTHLYPAYMENT_CONTENT]: 'Monthly payment of principal and interest collected by mortgage lenders; may also include escrowed items for taxes or insurance.',
  [IDS.TOOLTIP_REGULARMONTHLYPAYMENT_TITLE]: 'Regular Monthly Payments',
};

const enMurabahaMessages = {
  ...enMessages,
  // Additional Payment Fields
  [IDS.PAYMENTFIELDS_ADDITIONALPRINCIPAL_LABEL]: 'Additional Murabaha Payment',
  // Tooltips
  [IDS.TOOLTIP_ADDITIONALPAYMENTS_CONTENT]: 'Add additional funds to your monthly payment. Select from Additional Amounts Owed, Murabaha Payment, or Late fees if applicable.',
  [IDS.TOOLTIP_REGULARMONTHLYPAYMENT_CONTENT]: 'Monthly payment of installment amount collected by Murabaha Financing Transaction Financiers may also include escrowed items for taxes or insurance.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
